/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    MarkupV2FormConfiguration,
    MarkupV2FormConfigurationFromJSON,
    MarkupV2FormConfigurationToJSON,
    MarkupV2FormData,
    MarkupV2FormDataFromJSON,
    MarkupV2FormDataToJSON,
    MarkupV2ListItem,
    MarkupV2ListItemFromJSON,
    MarkupV2ListItemToJSON,
    MarkupV2ValidationData,
    MarkupV2ValidationDataFromJSON,
    MarkupV2ValidationDataToJSON,
} from '../models';

export interface ApiMarkupsV2MarkupsV2FormCreatePostRequest {
    markupV2FormData?: MarkupV2FormData;
}

export interface ApiMarkupsV2MarkupsV2FormDeleteDeleteRequest {
    id?: string;
}

export interface ApiMarkupsV2MarkupsV2FormGetByIdGetRequest {
    id?: string;
}

export interface ApiMarkupsV2MarkupsV2FormUpdatePostRequest {
    markupV2FormData?: MarkupV2FormData;
}

export interface ApiMarkupsV2MarkupsV2FormValidatePostRequest {
    markupV2FormData?: MarkupV2FormData;
}

/**
 * no description
 */
export class MarkupsV2FormApi extends runtime.BaseAPI {

    /**
     */
    async apiMarkupsV2MarkupsV2FormCreatePostRaw(requestParameters: ApiMarkupsV2MarkupsV2FormCreatePostRequest): Promise<runtime.ApiResponse<MarkupV2ListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/MarkupsV2/MarkupsV2Form/Create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MarkupV2FormDataToJSON(requestParameters.markupV2FormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MarkupV2ListItemFromJSON(jsonValue));
    }

    /**
     */
    async apiMarkupsV2MarkupsV2FormCreatePost(requestParameters: ApiMarkupsV2MarkupsV2FormCreatePostRequest): Promise<MarkupV2ListItem> {
        const response = await this.apiMarkupsV2MarkupsV2FormCreatePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiMarkupsV2MarkupsV2FormDeleteDeleteRaw(requestParameters: ApiMarkupsV2MarkupsV2FormDeleteDeleteRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/MarkupsV2/MarkupsV2Form/Delete`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiMarkupsV2MarkupsV2FormDeleteDelete(requestParameters: ApiMarkupsV2MarkupsV2FormDeleteDeleteRequest): Promise<void> {
        await this.apiMarkupsV2MarkupsV2FormDeleteDeleteRaw(requestParameters);
    }

    /**
     */
    async apiMarkupsV2MarkupsV2FormFormConfigurationGetRaw(): Promise<runtime.ApiResponse<MarkupV2FormConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/MarkupsV2/MarkupsV2Form/FormConfiguration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MarkupV2FormConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiMarkupsV2MarkupsV2FormFormConfigurationGet(): Promise<MarkupV2FormConfiguration> {
        const response = await this.apiMarkupsV2MarkupsV2FormFormConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiMarkupsV2MarkupsV2FormGetByIdGetRaw(requestParameters: ApiMarkupsV2MarkupsV2FormGetByIdGetRequest): Promise<runtime.ApiResponse<MarkupV2FormData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/MarkupsV2/MarkupsV2Form/GetById`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MarkupV2FormDataFromJSON(jsonValue));
    }

    /**
     */
    async apiMarkupsV2MarkupsV2FormGetByIdGet(requestParameters: ApiMarkupsV2MarkupsV2FormGetByIdGetRequest): Promise<MarkupV2FormData> {
        const response = await this.apiMarkupsV2MarkupsV2FormGetByIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiMarkupsV2MarkupsV2FormUpdatePostRaw(requestParameters: ApiMarkupsV2MarkupsV2FormUpdatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/MarkupsV2/MarkupsV2Form/Update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MarkupV2FormDataToJSON(requestParameters.markupV2FormData),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiMarkupsV2MarkupsV2FormUpdatePost(requestParameters: ApiMarkupsV2MarkupsV2FormUpdatePostRequest): Promise<void> {
        await this.apiMarkupsV2MarkupsV2FormUpdatePostRaw(requestParameters);
    }

    /**
     */
    async apiMarkupsV2MarkupsV2FormValidatePostRaw(requestParameters: ApiMarkupsV2MarkupsV2FormValidatePostRequest): Promise<runtime.ApiResponse<MarkupV2ValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/MarkupsV2/MarkupsV2Form/Validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MarkupV2FormDataToJSON(requestParameters.markupV2FormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MarkupV2ValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiMarkupsV2MarkupsV2FormValidatePost(requestParameters: ApiMarkupsV2MarkupsV2FormValidatePostRequest): Promise<MarkupV2ValidationData> {
        const response = await this.apiMarkupsV2MarkupsV2FormValidatePostRaw(requestParameters);
        return await response.value();
    }

}
